import React, { useState, useEffect, useContext } from 'react';
import style from './Discord.module.css';
import { AppContext } from '../../AppContext';

import Banner from '../Banner/Banner';
import icons from '../../icons';
import urls from '../../urls';


const Discord = props => {
    const { user } = useContext(AppContext);
    const [school, setSchool] = useState("");
    const [discordName, setDiscordName] = useState(undefined);
    const [discordAvatar, setDiscordAvatar] = useState(undefined);
    const [discordBannerColor, setDiscordBannerColor] = useState(undefined);
    const [loggedInDiscord, setLoggedInDiscord] = useState(false);
    const [activity, setActivity] = useState("Connessione a Discord");
    const [loading, setLoading] = useState(true);

    const getSchool = schoolCode => {
        return fetch(urls.getSchool, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                schoolCode
            })
        }).then(res => res.json())
    }

    const linkDiscord = async () => {
        window.location.href = "https://discord.com/api/oauth2/authorize?client_id=1011263490113163324&redirect_uri=https%3A%2F%2Fschool-diary-app.netlify.app%2Fdiscord&response_type=token&scope=identify%20email";
    };

    const unLinkDiscord = async () => {
        fetch(urls.revokeDiscord, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                userId: user?.id
            })
        }).then(res => {
            if (res.ok) {
                setDiscordAvatar(undefined);
                setDiscordBannerColor(undefined);
                setActivity("Connessione a Discord");
                setLoggedInDiscord(false);
            } else console.warn(res);
        }).catch(err => {
            console.warn(`Error unlinking Discord account: ${err}`);
        })
    }

    useEffect(() => {
        (async () => {
            const fragment = new URLSearchParams(window.location.hash.slice(1));
            const [accessToken, tokenType] = [fragment.get('access_token'), fragment.get('token_type')];

            if (!user) 
                return;

            setSchool((await getSchool(user.school))?.[0]?.["miur:DENOMINAZIONESCUOLA"]);

            let response = await fetch(urls.discord, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ userId: user.id })
            });
            
            const { discordId } = await response.json();
            if (discordId) {
                try {
                    response = await fetch(urls.getDiscordUserData, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({ userId: discordId })
                    });

                    const { username, discriminator, avatar, banner_color, id } = await response.json();
                    setDiscordName(`${username}#${discriminator}`);
                    if (!banner_color)
                        setDiscordBannerColor(banner_color);
                    setActivity("Connesso a Discord");
                    setLoggedInDiscord(true);
                    setLoading(false);
                    if (avatar)
                        setDiscordAvatar(`https://cdn.discordapp.com/avatars/${id}/${avatar}`);

                    return;
                } catch (err) {
                    console.warn(`Error while getting data about Discord account with id ${discordId}. This probably means the account hasn't joined the Discord server yet`);
                    setActivity("Connesso all'account Discord - non nel server");
                }

                setLoggedInDiscord(true);
            }

            if (!accessToken || discordName) {
                setLoading(false);
                return;
            }

            response = await fetch(urls.discord, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    accessToken,
                    tokenType,
                    userId: user.id
                })
            });

            const { username, discriminator, avatar, banner_color, id } = await response.json();

            fetch(urls.getDiscordUserData, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ userId: id })
            }).catch(null);

            setActivity("Connesso a Discord");
            setDiscordName(`${username}#${discriminator}`);
            setDiscordBannerColor(banner_color);
            setLoggedInDiscord(true);
            setLoading(false);
            if (avatar)
                setDiscordAvatar(`https://cdn.discordapp.com/avatars/${id}/${avatar}`);
        })();
    }, [user, discordName]);

    return <main className={ style.main }>
        <Banner />
        <div className={ style.discordCard }>
            <section className={ style.topColorBanner } style={{ background: discordBannerColor ?? "var(--orange)" }}></section>
            <img src={ discordAvatar ?? user?.profilePicture ?? icons.cartoon_avatar_icon } referrerPolicy="no-referrer" className={ style.avatar }></img>
            <h2 className={ style.username }>{ (discordName && loggedInDiscord) ? discordName : user?.username }{ (!discordName || !loggedInDiscord) && <span style={{ color: "#c1c3c5" }}>#0000</span> }</h2>
            <div className={ style.separator }></div>
            <h3 className={ style.activityLabel }>GIOCANDO A</h3>
            <div className={ style.activity }>
                <img src={ icons.discord_icon } className={ style.activityIcon }></img>
                <div>
                    <h4 style={{ marginTop: "1.75rem" }}>Discord</h4>
                    <h5 style={{ marginTop: "-1rem", marginRight: "1rem" }}>{ activity }</h5>
                    {/* <h5 style={{ marginTop: "-1rem" }}>{ loggedInDiscord ? "Connesso" : "Connessione" } a Discord</h5> */}
                </div>
            </div>
            <h3 className={ style.rolesLabel }>RUOLI</h3>
            <div className={ style.roles }>
                <div className={ style.role } style={{ marginLeft: "1rem" }}>
                    <div></div>
                    <h4>{ school }</h4>
                </div>
                <div className={ style.role }>
                    <div></div>
                    <h4>{ user?.class }</h4>
                </div>
            </div>
        </div>
        { loading ? 
            <div className={ style.button }>
                <div className={ style.spinner }></div>
            </div> : loggedInDiscord ? 
            <div className={ style.button } style={{ background: "linear-gradient(to right, rgb(89, 0, 255), rgb(81, 0, 187))" }} onClick={ unLinkDiscord }>
                <img src={ icons.logout_icon }></img>
                <h3>SCOLLEGA ACCOUNT</h3>
            </div> : 
            <div className={ style.button } onClick={ linkDiscord }>
                <img src={ icons.login_icon }></img>
                <h3>COLLEGA ACCOUNT</h3>
            </div> 
        }
        <div className={ style.button } onClick={ () => window.location.href = "/" }>
            <img src={ icons.home_icon }></img>
            <h3>VAI ALLA HOME</h3>
        </div> 
    </main>
};

export default Discord;
